// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Bu14h","loginBlock":"Header_loginBlock__l0NaE"};